import React, {useEffect, useState} from "react";
import {Btn, FormInput, FormSelect, ModalVoucherSearch, Toggle} from "./";
import {useCore} from "../hooks";
import {PaymentItem, Voucher} from "depoto-core";
import {formatDate, formatPrice, updateBill} from "../utils";

export const PaymentItemCoupon: React.FC = () => {
  const { currentOrder, setCurrentOrder, orderVouchers, setOrderVouchers, currency } = useCore()
  // const updatePaymentItems = (paymentItems?: PaymentItem[]) => {
  //   const nextOrder = {...currentOrder}
  //   nextOrder.paymentItems = paymentItems?.length ? [...paymentItems] : []
  //   setCurrentOrder(nextOrder)
  // }

  const removeVoucher = (voucher: Partial<Voucher>) => {
    const nextVouchers = [...orderVouchers].filter(v => v.id !== voucher.id)
    setOrderVouchers(nextVouchers)
    if (voucher.discountType === 'percentage') {
      const nextPercentageSales = [...(currentOrder.percentageSales || [])].filter(ps => ps.name !== voucher.name && ps.code !== voucher.code)
      currentOrder.percentageSales = nextPercentageSales
      updateBill({ currentOrder, setCurrentOrder })
    } else {
      const nextOrder = {...currentOrder}
      nextOrder.paymentItems = nextOrder.paymentItems.filter(pi => !pi?.voucher || (pi?.voucher?.code?.length > 0 && pi.voucher.code !== voucher.code))
      updateBill({ currentOrder: nextOrder, setCurrentOrder })
    }
  }

  return (
    <div>
      {orderVouchers?.length > 0 ?
        orderVouchers.map((v, i) => (
          <div className="flex flex-row justify-between items-center" key={`selected-voucher-${v.code}-${v.id}-${i}`}>
            <div>{v.code}</div>
            <div>{v.name}</div>
            <div>{v.isValid}</div>
            <div>{formatDate(new Date(v.validTo), false)}</div>
            <div>{v.discountType === 'percentage' ? `${v.discountPercent}%` : formatPrice(v.discountValue, currency.id)}</div>
            <Btn className="btn-primary" icon={'fa-trash'} onClick={() => removeVoucher(v)}/>
          </div>
        )) : null}
      <div>
        <ModalVoucherSearch />
      </div>
    </div>
  )
}
